import { render } from "./CursosInscripcionesDetalle.vue?vue&type=template&id=5754f546&scoped=true&ts=true"
import script from "./CursosInscripcionesDetalle.vue?vue&type=script&lang=ts"
export * from "./CursosInscripcionesDetalle.vue?vue&type=script&lang=ts"

import "./CursosInscripcionesDetalle.vue?vue&type=style&index=0&id=5754f546&scoped=true&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5754f546"]])

export default __exports__